import Domain from "./domain";
export default {
  methods: {
    getClassTypes: async function() {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "customer/company/class/type/details",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postClassType: async function(obj) {
      try {
        console.log(obj);
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/company/class/type",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postClassTypeBulk: async function(obj) {
      try {
        let objs = obj.map(obj => {
          return { email: obj, year: obj, class_type: obj };
        });
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "customer/company/class/bulk",
          objs,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    deleteClassType: async function(id) {
      try {
        let response = await this.axios.delete(
          Domain.APP_DOMAIN + "customer/company/class/type/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
